export const PAGE_SIZE = 8;
export const REVIEW_ITEM_HEIGHT = 4.75; // rem

export const MAX_REVIEW_TEXT_LENGTH = 750;
export const MAX_REVIEW_TITLE_LENGTH = 50;
